module.exports = "https://coursera_assets.s3.amazonaws.com/images/c7f7f2f130d025a6b86eb174d31d47db.svg";